// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sankey-report-container1{height:95%;display:flex;flex-flow:column;padding-right:10px}.modal-lg-generalFlow{width:910px}\n", ""]);
// Exports
module.exports = exports;
